let load = require('./helpers/browser/esm-js-loader-shards')(5);
module.exports = (load("fix5E")).then(() => parcelRequire('fPK4h'));